import { ChangeDetectorRef, Component, Inject, NgZone, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from 'src/app/_service/app.service';
import { UserModalComponent } from 'src/@common/user-modal/user-modal.component';
import { CommonService } from 'src/app/_service/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { PermissionService } from 'src/app/_service/permission.service';
import { ConfirmModalComponent } from 'src/@common/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-dialogeboxes',
  templateUrl: './dialogeboxes.component.html',
  styleUrls: ['./dialogeboxes.component.scss']
})
export class DialogeboxesComponent implements OnInit {
  private permissionsSubscription: Subscription;
  dialogData: any;
  userDialogRef: MatDialogRef<UserModalComponent>;
  object:any = {
    AccessInfo:{},
  }
  userData:any = {
    Department:{
      DepartmentId:0,
      DepartmentName:"",
    },
    Designation:{
      DesignationId:0,
      DesignationName:"",
    },
    Location:{},
    ActiveStatus:true,
  };
  imageSrc:any;
  showUploadPhoto = true;
  department:any = {
    AccessInfo:{},
    ActiveStatus:true,
  };
  designation:any = {
    AccessInfo:{},
    ActiveStatus:true,
  };
  departmentList:any[] = [];
  designationList:any[] = [];
  taskList: any;
  canAddTask: any;
  canEditTask: any;
  canDeleteTask: any;
  canViewTask: any;
  isAdmin: boolean=false;
  confirmDialog: MatDialogRef<ConfirmModalComponent>;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogeboxesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    public formBuilder: FormBuilder,
    private appService: AppService,
    public common:CommonService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private permissionService: PermissionService
  )
  {
    const usrdata = JSON.parse(localStorage.getItem('office_q_uid'));
    this.object.AccessInfo.UserId = usrdata.UserId;
    this.object.AccessInfo.UserLocationId = usrdata.UserLocationId;
    this.object.AccessInfo.CompanyId = usrdata.CompanyId;
    this.department.AccessInfo.UserId = usrdata.UserId;
    this.department.AccessInfo.UserLocationId = usrdata.UserLocationId;
    this.department.AccessInfo.CompanyId = usrdata.CompanyId;
    this.designation.AccessInfo.UserId = usrdata.UserId;
    this.designation.AccessInfo.UserLocationId = usrdata.UserLocationId;
    this.designation.AccessInfo.CompanyId = usrdata.CompanyId;
    this.isAdmin = usrdata.IsAdmin;
    console.log("data",data);
    this.dialogData = data;
    console.log(' this.dialogData: ',  this.dialogData);

}

    // Method to close the dialog
    onClose(): void {
      this.dialogRef.close(); // Close the dialog without any result
    }

    submit() {
      console.log(this.userData);
      this.userData.Location.LocationId = this.object.AccessInfo.UserLocationId;
      this.userData.CompanyId = this.object.AccessInfo.CompanyId;
      this.appService.postService({...this.userData}, 'UserSave')
      .subscribe(response => {
        console.log(response)
      });
      // Perform any actions here (e.g., save the new project)

      this.dialogRef.close(true); // Pass `true` to indicate success
    }


  ngOnInit() {


    if (this.dialogData.action === 'RelatedTask') {
      this.permissionsSubscription = this.permissionService.permissions$.subscribe(permissions => {
        if (permissions.length > 0) {
          this.updatePermissions();
          this.cdr.detectChanges(); // Ensure UI updates
        } else {
          this.permissionService.userList();
        }
      });
      setTimeout(() => this.getTaskDashList());
    }else{
      this.getDepartmentDropDownList();
      this.getDesignationDropdownList();
    }

  }
  updatePermissions() {
    this.canAddTask = this.permissionService.hasPermission(1, 'Add');
    this.canEditTask = this.permissionService.hasPermission(1, 'Edit');
    this.canDeleteTask = this.permissionService.hasPermission(1, 'Delete');
    this.canViewTask = this.permissionService.hasPermission(1, 'View');

    // console.log('Permissions updated:', {
    //   Add: this.canAddSociety,
    //   Edit: this.canEditSociety,
    //   Delete: this.canDeleteSociety,
    //   View: this.canViewSociety
    // });
  }
  getDepartmentDropDownList(){
    this.appService.postService({...this.object}, 'GetDepartmentDropdownList')
    .subscribe(response => {
      console.log(response)
      this.departmentList = response.body.Result;
      const a = this.departmentList.sort((a, b) => {
        if (a.DepartmentName < b.DepartmentName) { return -1; }
        if (a.DepartmentName > b.DepartmentName) { return 1; }
        return 0;
      })
    });
  }

  getDesignationDropdownList(){
    this.appService.postService({...this.object}, 'GetDesignationDropdownList')
    .subscribe(response => {
      console.log(response)
      this.designationList = response.body.Result;
      const a = this.designationList.sort((a, b) => {
        if (a.DesignationName < b.DesignationName) { return -1; }
        if (a.DesignationName > b.DesignationName) { return 1; }
        return 0;
      })
    });
  }

  getTaskDashList(): void {
    this.spinner.show();

    this.appService.postService(this.object, 'TaskList').subscribe({
      next: (response) => {
        this.spinner.hide();
        console.log(response);

        if (response.body.TaskList) {
          this.zone.run(() => {

            this.taskList = response.body.TaskList.filter((item: any) =>
                item.EarlierTaskAttached &&
                item.EarlierTaskAttached.TaskId &&
                item.Id != this.dialogData.data.Id &&
                item.EarlierTaskAttached.TaskId === this.dialogData.data.EarlierTaskAttached.TaskId
            );



          });
        } else {
          this.taskList = [];
          console.warn('TaskList is null or undefined');
        }
      },
      error: (error) => {
        console.error('Error fetching task list:', error);
        this.taskList = [];
        this.spinner.hide();
      }
    });
  }

  adddepartmentpopup(){
    const dialogRef = this.dialog.open(DialogeboxesComponent, {
     // width: '800px',
      //height: 'auto',
     // panelClass: "modal-sm",
      autoFocus: true,
      restoreFocus: false,
      disableClose: false,
      data: { action: 'AddDepartmentPopupModel', title: 'User Registration', data: null },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === true) {
      }
    });
  }

  addNewDepartment(){
    this.appService.postService({...this.department}, 'DepartmentSave')
    .subscribe(response => {
      console.log(response)
      this.getDepartmentDropDownList();
    });
  }

  deleteDepartment(item:any){
    this.department.Id = item.DepartmentId;
    this.appService.postService({...this.department}, 'DepartmentDelete')
    .subscribe(response => {
      console.log(response)
      this.getDepartmentDropDownList();
    });

  }

  addDesignationpopup(){
    const dialogRef = this.dialog.open(DialogeboxesComponent, {
     // width: '800px',
      //height: 'auto',
     // panelClass: "modal-sm",
      autoFocus: true,
      restoreFocus: false,
      disableClose: false,
      data: { action: 'AddDesignationPopupModel', title: 'User Registration', data: null },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === true) {
      }
    });
  }

  addNewDesignation(){
    this.appService.postService({...this.designation}, 'DesignationSave')
    .subscribe(response => {
      console.log(response)
      this.getDesignationDropdownList();
    });
  }

  deleteDesignation(item:any){
    this.designation.Id = item.DesignationId;
    this.appService.postService({...this.designation}, 'DesignationDelete')
    .subscribe(response => {
      console.log(response)
      this.getDesignationDropdownList();
    });
  }

  doApprove(obj:any){
    // this.appService.postService({...obj}, 'TaskDelete')
    // .subscribe(response => {
    //   console.log(response)
    //   //this.getTaskDashList();
    // });
  }

  openToModal(){
    this.userDialogRef = this.dialog.open(UserModalComponent, {
      autoFocus: false,
      panelClass: 'user_model',
      data: { userData: this.dialogData.data.AssignTo }
    });
    this.userDialogRef.afterClosed()
      .subscribe(result => {
        if (!result) {
          return;
        } else {
          this.dialogData.data.AssignTo = result;
        }
      });
  }
  updateTaskStatus(status: number) {
    this.dialogData.data.Status = status;
    this.appService.postService({...this.dialogData.data}, 'TaskUpdate')
      .subscribe({
        next: (response) => {
          console.log(response);
          // Close dialog only once with success true
          this.dialogRef.close({ success: true });
        },
        error: (error) => {
          console.error('Error updating task:', error);
          this.dialogRef.close({ success: false });
        }
      });
  }

  taskiassignto(usr:any){
    const dialogRef = this.dialog.open(DialogeboxesComponent, {
      width: '800px',
      height: 'auto',
      panelClass: "modal-sm",
      autoFocus: true,
      restoreFocus: false,
      disableClose: false,
      data: { action: 'TaskAssignto', title: 'User Registration', data: usr },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === true) {
      }
    });
}

toggleUploadMode() {
  this.showUploadPhoto = !this.showUploadPhoto;
}

onFileSelected(event:any){
  const file = (event.target as HTMLInputElement).files[0];
		if (file) {
			const reader = new FileReader();
			reader.onload = () => {
				this.imageSrc = reader.result as string; // Preview the uploaded image
				this.userData.PhotoName = file.name; // Store the file name
				this.userData.PhotoPath = reader.result as string;
			};
			reader.readAsDataURL(file);
		}
}
onEdit(id: number): void {
  this.dialogRef.close(); // Close the dialog
  this.router.navigate(['/app/dashboard/task/add-task'], { queryParams: { Id: id } });
}
onDelete(model: any) {

      this.confirmDialog = this.dialog.open(ConfirmModalComponent, {
      autoFocus: false,
      panelClass: 'modal-xs',
      disableClose: true,
      data: { action: 'delete', title: 'Are you sure you want to delete this program?' }
    });
    this.confirmDialog.afterClosed()
      .subscribe(result => {
        if (!result) {
          return;
        } else {
        this.appService.postService(model, 'TaskDelete')
    .subscribe({
      next: (response) => {
        console.log(response);
        // Close dialog with success flag
        this.dialogRef.close({ success: true });
      },
      error: (error) => {
        console.error('Error deleting task:', error);
        this.dialogRef.close({ success: false });
      }
    });
        }
      });


}
taskispending(taskItem: any) {
  console.log('taskItem: ', taskItem);
    const dialogRef = this.dialog.open(DialogeboxesComponent, {
      width: '800px',
      height: 'auto',
      panelClass: "modal-sm",
      autoFocus: true,
      restoreFocus: false,
      disableClose: false,
      data: { action: 'TaskPending', title: 'User Registration', data: taskItem,
        canAddTask: this.canAddTask,
        canEditTask: this.canEditTask,
        canDeleteTask: this.canDeleteTask,
        canViewTask: this.canViewTask,
        isAdmin: this.isAdmin,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === true) {
      }
    });
  }
  openDocumentPdfInNewTab(box: any) {
    if (!box.Attachment.FileData) {
      console.error('No PDF data available');
      return;
    }

    try {
      const pdfUrl = `data:application/pdf;base64,${box.Attachment.FileData}`;

      // Create a safe document structure
      const newTab = window.open();
      if (newTab) {
        newTab.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>${box.Attachment.DocumentFileName || 'PDF Preview'}</title>
              <style>
                body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
                iframe { width: 100%; height: 100%; border: none; }
              </style>
            </head>
            <body>
              <iframe src="${pdfUrl}" type="application/pdf"></iframe>
            </body>
          </html>
        `);
        newTab.document.close();
      } else {
        console.error('Failed to open new tab. Pop-up might be blocked.');
      }
    } catch (error) {
      console.error('Error opening PDF:', error);
    }
  }
  isMarkAsDoneVisible(): boolean {
  const { data } = this.dialogData;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const hasPastDueDate = data.TargetDate.some(dateObj => {
    const dueDate = new Date(dateObj.DueDate);
    dueDate.setHours(0, 0, 0, 0);
    return dueDate < today;
  });

  return (
    !hasPastDueDate
  );
}

}
